import {Pipe, PipeTransform} from '@angular/core';
import {Adres} from '../adres';

@Pipe({
    name: 'zahGemeente',
    standalone: false
})
export class GemeentePipe implements PipeTransform {
  transform(adres: Adres): string {
    return `${adres.getPostcode()} ${adres.getGemeente()}`;
  }
}
